export const MINI_CHART = {
  SET_PRICE_SOURCE: 'MINI_CHART/SET_PRICE_SOURCE', // 'price' | 'mark'
  SET_RESOLUTION: 'MINI_CHART/SET_RESOLUTION', // e.g., '1','5','60','D','1W'
  SET_SYMBOL: 'MINI_CHART/SET_SYMBOL', // derived from product + price source
  REQUEST_HISTORY: 'MINI_CHART/REQUEST_HISTORY',
  HISTORY_SUCCESS: 'MINI_CHART/HISTORY_SUCCESS',
  HISTORY_FAILURE: 'MINI_CHART/HISTORY_FAILURE',
  RESET: 'MINI_CHART/RESET',
} as const;

export type MiniChartPriceSource = 'price' | 'mark';
